import React from 'react'
import SVGIcon from 'components/presenters/common/SVGIcon'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

export default function ManageOptionList({ unreadPaybackNum }) {
  return (
    <Section>
      <OptionList>
        <SectionHeader>주문현황</SectionHeader>
        <CommerceBody>
          <CommerceItemLeft>
            <CommerceItem to={`/motishop/order`}>
              <CommerceIcon>
                <SVGWrapper heightVal={32} widthVal={32}>
                  <SVGIcon name={'document'} fill={'#FF9B57'} />
                </SVGWrapper>
              </CommerceIcon>
              <CommerceTxt>주문내역</CommerceTxt>
            </CommerceItem>
          </CommerceItemLeft>
          <CommerceItemRight>
            <CommerceItem to={`/motishop/payback`}>
              <CommerceIcon>
                {Number.isInteger(unreadPaybackNum) && unreadPaybackNum > 0 && (
                  <NoteCount>{unreadPaybackNum}</NoteCount>
                )}

                <SVGWrapper heightVal={25} widthVal={34}>
                  <SVGIcon name={'banknote'} fill={'#FF9B57'} />
                </SVGWrapper>
              </CommerceIcon>
              <CommerceTxt>환급내역</CommerceTxt>
            </CommerceItem>
          </CommerceItemRight>
        </CommerceBody>
      </OptionList>
      <OptionList>
        <SectionHeader>챌린지 관리</SectionHeader>
        <SectionBody>
          <SectionItem to={`/mypage/projects/list`}>참여 챌린지</SectionItem>
          <SectionItem to={`/calendar`}>캘린더</SectionItem>
          <SectionItem to={`/archive`}>인증기록</SectionItem>
          <SectionItem to={`/routine/list`}>루틴관리</SectionItem>
        </SectionBody>
      </OptionList>
      <OptionList>
        <SectionHeader>이용 안내</SectionHeader>
        <SectionBody>
          <SectionExternalItem href="https://pf.kakao.com/_gmtJs/chat" target="_blank">
            1:1 문의
          </SectionExternalItem>
          <SectionItem to={`/mypage/policy/list`}>약관 및 정책</SectionItem>
        </SectionBody>
      </OptionList>
    </Section>
  )
}
export const Section = styled.div``
export const OptionList = styled.div`
  padding: 0 calc(100vw * (17 / 375)) calc(100vw * (18 / 375)) calc(100vw * (17 / 375));
  border-bottom: solid calc(100vw * (12 / 375)) #f7f7f7;
`

export const SectionHeader = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  color: #000000;
  padding: calc(100vw * (21 / 375)) 0 calc(100vw * (20 / 375));
`
export const SectionBody = styled.div``
export const SectionItem = styled(Link)`
  display: block;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #121212;
  padding: calc(100vw * (15 / 375)) 0;
`
export const SectionExternalItem = styled.a`
  display: block;
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #121212;
  padding: calc(100vw * (15 / 375)) 0;
`

export const CommerceIcon = styled.div`
  display: inline-block;
  width: calc(100vw * (79 / 375));
  height: calc(100vw * (79 / 375));
  background: #fffbf0;
  border-radius: 100%;
  position: relative;
  margin-bottom: calc(100vw * (14 / 375));
`
export const NoteCount = styled.div`
  color: white;
  background: #121212;
  width: calc(100vw * (27 / 375));
  height: calc(100vw * (27 / 375));
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: calc(100vw * (-7 / 375));
  top: calc(100vw * (-2 / 375));
`
export const SVGWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: inline-block;
  width: ${({ widthVal }) => {
    return widthVal ? `calc(100vw * (${widthVal} / 375))` : null
  }};
  height: ${({ heightVal }) => {
    return heightVal ? `calc(100vw * (${heightVal} / 375))` : null
  }};

  svg {
    color: #ff9b57;
  }
`

export const CommerceBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: calc(100vw * (9 / 375));
`
export const CommerceItemLeft = styled.div`
  padding-right: calc(100vw * (23 / 375));
`
export const CommerceItemRight = styled.div`
  padding-left: calc(100vw * (23 / 375));
`
export const CommerceItem = styled(Link)`
  display: block;
  text-align: center;
`
export const CommerceTxt = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
`
